import FoodItemCard from "../../../components/common/FoodItemCard";
import AddItemSection from "../../../components/common/AddItemSection";

interface FoodItem {
  id: number;
  food_item_id?: string;
  name: string;
  calories: number;
  weight: number;
  servings: number;
  image: string;
  carbohydrate_content_g?: number;
  protein_content_g?: number;
  fat_content_g?: number;
  dietary_fiber_g?: number;
  net_carbs_g?: number;
  sugar_g?: number;
  trans_fat_g?: number;
  saturated_fat_g?: number;
  GI_estimate?: number;
  GL_estimate?: number;
  serving_description?: string;
}

interface FoodItemsListProps {
  foodItems: FoodItem[];
  uploadedImage: string | null;
  expandedItems: Set<number>;
  onToggleExpanded: (itemId: number) => void;
  onEditItem: (item: FoodItem) => void;
  onDeleteItem: (itemId: number) => void;
  onAddItem: () => void;
}

const FoodItemsList: React.FC<FoodItemsListProps> = ({
  foodItems,
  uploadedImage,
  expandedItems,
  onToggleExpanded,
  onEditItem,
  onDeleteItem,
  onAddItem,
}) => {
  if (foodItems.length === 0) {
    return (
      <div className="mb-6">
        <div className="rounded-2xl border border-border bg-card p-6 text-center shadow-lg">
          <div className="mb-4 text-blue-400">
            <span className="text-lg">🍽️</span>
          </div>
          <p className="mb-2 text-base font-medium text-foreground">
            No food items detected
          </p>
          <p className="text-sm text-muted-foreground">
            Please upload an image to scan food items or add items manually
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-bold text-foreground">Food Items</h2>
        <AddItemSection onAddItem={onAddItem} />
      </div>
      {foodItems.map(item => (
        <FoodItemCard
          key={item.id}
          item={item}
          uploadedImage={uploadedImage}
          isExpanded={expandedItems.has(item.id)}
          onToggleExpanded={onToggleExpanded}
          onEditItem={onEditItem}
          onDeleteItem={onDeleteItem}
        />
      ))}
    </div>
  );
};

export default FoodItemsList;
